module.exports = __webpack_public_path__ + "img/ywbk12_en.af8684ea.jpg";